import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SalesAutomationStageGoal as SalesAutomationStageGoalFragment,
    StageGoalsForStage as StageGoalsForStageQuery,
    StageGoalsForStageVariables as StageGoalsForStageQueryVariables,
} from 'nutshell-graphql-types';

import {GOALS} from '../../constants';
import GET_STAGE_GOALS_FOR_STAGE from '../../graphql/queries/get-stage-goals-for-stage.graphql';

import {SalesAutomationCardGoal} from '../cards/sales-automation-card-goal';

import {StageSingleItemContainer} from './stage-single-item-container';

type OwnProps = {
    parentId: string;
    hideCards: boolean;
};

type GraphQLProps = {
    isLoadingGoals: boolean;
    errorMessage: string | null | undefined;
    goals: SalesAutomationStageGoalFragment[];
};

type Props = OwnProps & GraphQLProps;

export class StageCardsGoalsContainerComponent extends React.PureComponent<Props> {
    render() {
        // Technically there can only be one goal per-stage right now,
        // but since our API intends to eventually support more, I'm
        // leaving this as "goalCards" multiple, and just grabbing the
        // first in the list.
        const goalCards = this.props.goals.map((goal) => {
            return (
                <SalesAutomationCardGoal
                    key={goal.id}
                    isHidden={this.props.hideCards}
                    parentId={this.props.parentId}
                    goal={goal}
                />
            );
        });

        return (
            <StageSingleItemContainer
                type={GOALS}
                isLoading={this.props.isLoadingGoals}
                errorMessage={this.props.errorMessage}
                item={goalCards[0]}
                parentId={this.props.parentId}
                hideAddCard={this.props.hideCards}
            />
        );
    }
}

class GoalsQuery extends Query<StageGoalsForStageQuery, StageGoalsForStageQueryVariables> {}

export const StageCardsGoalsContainer = (props: OwnProps) => (
    <GoalsQuery query={GET_STAGE_GOALS_FOR_STAGE} variables={{stageId: props.parentId}}>
        {({data, loading, error}) => {
            const editableGoals = data ? data.editableGoals : null;

            return (
                <StageCardsGoalsContainerComponent
                    {...props}
                    isLoadingGoals={loading}
                    // @ts-expect-error
                    errorMessage={safelyGetGraphQLErrorMessage(error)}
                    goals={editableGoals || []}
                />
            );
        }}
    </GoalsQuery>
);
